$(document).ready(function(){
  $('.devThumbSlider').slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    vertical: true,
    prevArrow:"<button type='button' class='slick-prev pull-left'><img src='//www.tyresouqarabia.com/cdn/shop/t/27/assets/leftAngle.png?v=79036403307400866581786912597'></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><img src='//www.tyresouqarabia.com/cdn/shop/t/27/assets/rightAngle.png?v=28193544195749049521786912597'></button>"
  });
  
  $(".findTireSize p").on("click" , function(){
    $(".tireSizePopup").show();  
  });

  $(".closeButton svg").on("click" , function(){
    $(".tireSizePopup").hide(); 
     $(".devpopupBackground").hide();
  });

  $(".findTireSize p").on("click" , function(){
    $(".devpopupBackground").show();  
  });

  $(".devMyAccount .accountLogoutBtn svg , .devMyAccount .accountLogoutBtn button").on("click" , function(){
    $("#accountLogout").hide();  
  });

  $(".devMyAccount #logoutButton").on("click" , function(){
    $("#accountLogout").show();  
  });

  $(".devMyAccount .accountButtons p").on("click" , function(){
    //console.log("show active");
    $(this).addClass("active");  
    $(this).siblings().removeClass("active")
  });

  $(".devMyAccount .accountButtons #accountButton").on("click" , function(){
    $("#myOrders").hide();
    $("#myAccount").show();
  });

  $(".devMyAccount .accountButtons #orderButton").on("click" , function(){
    $("#myAccount").hide();
    $("#myOrders").show();
  });


  $('.locationButton').on('click', function(e){
    e.preventDefault();
    $('.dev_locationPopup').css('display', 'block');
    $('.dev_popupOverlay').css('display', 'block');
    $('body').addClass('dev_popupShow');
  });
  
  $('.dev_close').on('click', function(){
    $('.dev_locationPopup').css('display', 'none');
    $('.dev_popupOverlay').css('display', 'none');
    $('body').removeClass('dev_popupShow');
  });
  
  $('.dev_popupOverlay').on('click', function(event){
    if(event.target.id=="dev_outerOverlay"){
      $('.dev_locationPopup').css('display', 'none');
      $(this).css('display', 'none');
      $('body').removeClass('dev_popupShow');
    }

  });

});